// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"bq-z","breadcrumbForward":"cq-z","breadcrumbBack":"dq-z","selected":"eq-z"};